// extracted by mini-css-extract-plugin
export var pillWrapper = "_ns-0";
export var showOverflow = "_ns-1";